export default __webpack_public_path__ + "ableton-live.8e3f345a.png";